// A/B checkout stamping: write this theme copy's fixed A/B variant onto the cart as a cart
// attribute so the checkout extensions can read it. Loaded as a deferred script, so the DOM
// is already parsed and the stamp can start immediately.
(() => {
  function readDesiredAttributes() {
    const dataEl = document.getElementById('ab-checkout-data');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  async function stampAbAttributes() {
    const want = readDesiredAttributes();
    if (!want) return;

    try {
      const cart = await fetch(`${routes.cart_url}.js`).then((r) => r.json());

      const patch = {};
      for (const [key, value] of Object.entries(want)) {
        if (String(cart.attributes?.[key] ?? '') !== String(value)) patch[key] = value;
      }
      if (!Object.keys(patch).length) return;

      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: patch }),
      });
      if (!response.ok) return;
      const updated = await response.json();

      // PUB_SUB_EVENTS is a top-level `const` in constants.js (classic script), so it is a bare
      // global, not a window property. Guard with bare `typeof` (cf. conditional-discount-upsell.js:111),
      // never `window.PUB_SUB_EVENTS`.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-checkout', cartData: updated });
      }
    } catch (e) {
      // Non-fatal: re-attempted on the next page load.
    }
  }

  // Deferred script: the DOM is parsed and the data island is present, so stamp immediately.
  stampAbAttributes();
})();
